import { TableColumnInfo } from "@/Common/Models/UI/Tables/TableColumnInfo";

class PAListDisplaySettings {
    public UserId: string;
    public OrderedColumns: TableColumnInfo[];
    public SortByColumn: string;
    public IsAscendingSort: boolean;
}

export { PAListDisplaySettings };
